import type { SeoSegments } from '@handyhand/i18n';

import { Blog } from '@models/blog.model';
import type { AppEnv } from '../../../../../environments/app-env';

export function BlogPostingSchema(
  env: AppEnv,
  seg: SeoSegments,
  b: Blog,
  altTxt: string,
  desc: string,
  blogCat: string,
  headCat: string,
  i18n: { authorName: string },
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: b.title_tag || b.title,
    alternativeHeadline: altTxt,
    image: b.imgUrl,
    genre: blogCat,
    keywords: b.title,
    mainEntityOfPage: `${env.domain}/${seg.suffix.article}/${b.slug}`,
    publisher: {
      '@type': 'Organization',
      name: env.appName,
      logo: {
        '@type': 'ImageObject',
        url: `${env.cloudFrontImgUrl}/private/compressed/192x192_logo.webp`,
      },
    },
    url: `${env.domain}/${headCat}/${seg.suffix.article}/${b.slug}/${seg.suffix.guide}`,
    datePublished: b.date,
    dateCreated: b.date,
    dateModified: b.modified,
    description: altTxt,
    articleBody: desc,
    author: {
      '@type': 'Person',
      name: b.author ?? i18n.authorName,
    },
  };
}
